/**
 * Crawlable English copy + internal links for US visitors on `/` (USExclusiveLanding).
 * Complements video-first UX without breaking layout.
 */

import { Link } from "react-router-dom";
import { BRAND_PERSON_NAME } from "@/lib/brandConfig";
import { getHomeVariantForCountry } from "@/config/homeCountryVariants";

interface Props {
  countryCode: string;
}

export function USExclusiveLandingSeoFooter({ countryCode }: Props) {
  if (countryCode !== "US") return null;

  const variant = getHomeVariantForCountry("US");

  return (
    <footer
      className="pointer-events-auto absolute inset-x-0 top-0 z-[85] max-h-[38vh] overflow-y-auto bg-gradient-to-b from-black/85 via-black/55 to-transparent px-4 pb-6 pt-[max(0.75rem,env(safe-area-inset-top))] text-white/70 sm:max-h-none sm:overflow-visible"
      aria-label="About exclusive membership"
    >
      <p className="mx-auto max-w-lg text-center text-[11px] leading-relaxed sm:text-xs">
        <span className="font-semibold text-white/90">{variant.h1}</span>
        {" — "}
        {variant.tagline} Explore the{" "}
        <Link to="/en" className="text-amber-300/90 underline-offset-2 hover:underline">
          English home
        </Link>
        ,{" "}
        <Link to="/membership" className="text-amber-300/90 underline-offset-2 hover:underline">
          membership
        </Link>
        , and guides on{" "}
        <Link to="/ugc-creator" className="text-amber-300/90 underline-offset-2 hover:underline">
          UGC creators
        </Link>
        ,{" "}
        <Link to="/latina-models" className="text-amber-300/90 underline-offset-2 hover:underline">
          latina models
        </Link>
        , and{" "}
        <Link
          to="/how-to-become-an-influencer"
          className="text-amber-300/90 underline-offset-2 hover:underline"
        >
          becoming an influencer
        </Link>
        .
      </p>
      <p className="mx-auto mt-2 max-w-lg text-center text-[10px] leading-relaxed text-white/45 sm:text-[11px]">
        {variant.description} {BRAND_PERSON_NAME} offers premium visual content and a private
        community for fans in the United States and international audiences.
      </p>
    </footer>
  );
}